import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private apiUrl = environment.apiUrl;
  private tokenKey = 'token'; // Key where token is stored
  private userTypeKey = 'user_type'; // Key where user type is stored
  private router = inject(Router);

  constructor(private http: HttpClient) {}

  login(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/login`, data);
  }

  // Save token after login
  setToken(token: string): void {
    localStorage.setItem(this.tokenKey, token);
  }

  // Save token after login
  setUserType(userTypeKey: string): void {
    localStorage.setItem(this.userTypeKey, userTypeKey);
  }

  // Get token for API calls
  getToken(): string | null {
    return localStorage.getItem(this.tokenKey);
  }

  // Get stored user type
  getUserType(): string {
    return localStorage.getItem(this.userTypeKey) || '';
  }

  // Check if authenticated
  isAuthenticated(): boolean {
    const token = this.getToken();
    if (!token) {
      return false;
    }
    // Optionally: validate token expiry here by decoding JWT or calling backend
    return true;
  }

  // Clear token on logout
  logout(): void {
    localStorage.removeItem(this.tokenKey);
    localStorage.removeItem(this.userTypeKey);
    this.router.navigate(['/login']);
  }
}
